package com.shadowings.gero.domain.usecase

import com.shadowings.gero.domain.reminder.QuizReminderScheduler
import com.shadowings.gero.domain.repository.UserDataRepository
import com.shadowings.gero.util.currentDateAsInt
import com.shadowings.gero.util.dateIntToEpochDays
import com.shadowings.gero.util.epochDaysToDateInt
import kotlinx.coroutines.flow.first

class ScheduleQuizReminderUseCase(
    private val userDataRepository: UserDataRepository,
    private val reminderScheduler: QuizReminderScheduler,
) {
    suspend operator fun invoke(forceTomorrow: Boolean = false) {
        val reminderEnabled = userDataRepository.reminderEnabled.first()
        if (!reminderEnabled) {
            reminderScheduler.cancelReminder()
            return
        }

        val userData = userDataRepository.userData.first()
        val reminderHour = userDataRepository.reminderHour.first()
        val reminderMinute = userDataRepository.reminderMinute.first()
        val today = currentDateAsInt()
        val hasCompletedQuizToday = userData.lastQuizDate == today
        val targetDate = when {
            forceTomorrow -> nextDate(today)
            hasCompletedQuizToday -> nextDate(today)
            else -> today
        }

        reminderScheduler.scheduleReminder(
            dateAsInt = targetDate,
            hour = reminderHour,
            minute = reminderMinute,
        )
    }

    private fun nextDate(dateAsInt: Int): Int =
        epochDaysToDateInt(dateIntToEpochDays(dateAsInt) + 1)
}

